'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { LocalizedHtml, useI18n } from '@udemy-v2/i18n';
import styles from './blended-offer-badge.module.scss';
export interface BlendedOfferBadgeProps {
  termsUrl?: string;
  onLifetimeAccessClick: () => void;
}
export const BlendedOfferBadge = t0 => {
  const $ = _c(14);
  const {
    termsUrl,
    onLifetimeAccessClick
  } = t0;
  const {
    gettext
  } = useI18n();
  let t1;
  if ($[0] !== gettext) {
    t1 = gettext("<span class=\"emphasis\">Get</span> <span class=\"lifetime-access-link\">lifetime access</span> to this course for free when you subscribe. <span class=\"terms-link\">Terms apply</span>");
    $[0] = gettext;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const html = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon className={styles["value-prop-icon"]} glyph="verified" color="positive" size="small" label="" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className={styles.emphasis} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onLifetimeAccessClick) {
    t4 = <button type="button" className={styles["lifetime-access-link"]} onClick={onLifetimeAccessClick} data-purpose="blended-offer-lifetime-access-link" />;
    $[4] = onLifetimeAccessClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== termsUrl) {
    t5 = termsUrl ? <a href={termsUrl} target="_blank" rel="noopener noreferrer" className={styles["terms-link"]} data-purpose="blended-offer-terms-link" /> : <span />;
    $[6] = termsUrl;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = {
      emphasis: t3,
      "lifetime-access-link": t4,
      "terms-link": t5
    };
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== html || $[12] !== t6) {
    t7 = <div className={styles["value-prop-badge"]} data-purpose="blended-offer-badge">{t2}<span className={styles["value-prop-text"]}><LocalizedHtml html={html} interpolate={t6} /></span></div>;
    $[11] = html;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};